
// import React, { useState } from 'react';
// import { Link, useNavigate } from 'react-router-dom';
// import Login from '../../Authentication/Login'; // Adjust the import path as needed

// const PublicHeader = () => {
//     // modalStep: null | 'login'
//     const [modalStep, setModalStep] = useState(null);
//     const navigate = useNavigate();
//     const closeModal = () => setModalStep(null);

//     return (
//         <>
//             {/* NAVBAR */}
//             <nav className="navbar navbar-expand-lg navbar-light bg-white shadow-sm fixed-top py-3">
//                 <div className="container">
//                     <Link className="navbar-brand d-flex align-items-center" to="/">
                        
//                         {/* MF MONOGRAM */}
//                         <svg
//                             width="52"
//                             height="52"
//                             viewBox="0 0 180 120"
//                             xmlns="http://www.w3.org/2000/svg"
//                             style={{ marginRight: '5px' }}
//                         >
//                             <text
//                                 x="0"
//                                 y="90"
//                                 fontFamily="Playfair Display, Didot, serif"
//                                 fontSize="96"
//                                 fontWeight="700"
//                                 letterSpacing="-10"
//                                 fill="#111"
//                             >
//                                 MF
//                             </text>
//                         </svg>

//                         {/* WORDMARK */}
//                         <div className="d-flex flex-column">
//                             <span
//                                 style={{
//                                     fontSize: '1.05rem',
//                                     fontWeight: '500',
//                                     letterSpacing: '0.35rem',
//                                     color: '#111',
//                                     lineHeight: '1.1'
//                                 }}
//                             >
//                                 MUNNY FINDS
//                             </span>

//                             <span
//                                 style={{
//                                     fontSize: '0.55rem',
//                                     letterSpacing: '0.25rem',
//                                     fontWeight: '600',
//                                     color: '#6b7280',
//                                     marginTop: '2px'
//                                 }}
//                             >
//                                 BEAUTY & CARE
//                             </span>
//                         </div>

//                     </Link>

//                     <button 
//                         className="navbar-toggler" 
//                         type="button" 
//                         data-bs-toggle="collapse" 
//                         data-bs-target="#navbarNav" 
//                         aria-controls="navbarNav" 
//                         aria-expanded="false" 
//                         aria-label="Toggle navigation"
//                     >
//                         <span className="navbar-toggler-icon"></span>
//                     </button>

//                     <div className="collapse navbar-collapse" id="navbarNav">
//                         <ul className="navbar-nav mx-auto mb-2 mb-lg-0 gap-lg-3">
//                             <li className="nav-item">
//                                 <Link className="nav-link fw-semibold text-dark" to="/">Home</Link>
//                             </li>
//                              <li className="nav-item">
//     <Link className="nav-link fw-semibold text-dark" to="/all-categories">Categories</Link>
// </li>
//                             <li className="nav-item">
//                                 <Link className="nav-link fw-semibold text-dark" to="/products/search">Products</Link>
//                             </li>
                            
//                             {/* NEW CATEGORIES LINK ADDED HERE */}
              

//                             <li className="nav-item">
//                                 <Link to="/about-us" className="nav-link fw-semibold text-dark">About Us</Link>
//                             </li>
//                             <li className="nav-item">
//                                 <Link to="/contact" className="nav-link fw-semibold text-dark">Contact</Link>
//                             </li>
//                         </ul>
                        
//                         <div className="d-flex align-items-center gap-3">
//                             {/* LOGIN BUTTON */}
//                             <button 
//                                 onClick={() => setModalStep('login')} 
//                                 className="btn btn-link text-decoration-none fw-bold text-dark me-2 shadow-none"
//                                 style={{ fontSize: '0.95rem' }}
//                             >
//                                 Log In
//                             </button>
                            
//                             {/* CUSTOMER REGISTRATION BUTTON */}
//                             {/* <button 
//                                 onClick={() => navigate('/register-customer')} 
//                                 className="btn px-3 py-2 fw-bold text-white rounded-3 shadow-sm" 
//                                 style={{ 
//                                     backgroundColor: '#065f46', 
//                                     fontSize: '0.85rem',
//                                     minWidth: '140px'
//                                 }}
//                             >
//                                 <i className="ri-user-heart-line me-1"></i> I am a Customer
//                             </button> */}
                            
//                             {/* BUSINESS REGISTRATION BUTTON */}
//                             <button 
//                                 onClick={() => navigate('/register-business')} 
//                                 className="btn px-3 py-2 fw-bold text-white rounded-3 shadow-sm" 
//                                 style={{ 
//                                     backgroundColor: '#059669', 
//                                     fontSize: '0.85rem',
//                                     minWidth: '140px'
//                                 }}
//                             >
//                                 <i className="ri-building-4-line me-1"></i> Business Owner
//                             </button>
//                         </div>
//                     </div>
//                 </div>
//             </nav>

//             {/* --- LOGIN MODAL ONLY --- */}
//             {modalStep === 'login' && (
//                 <Login
//                     closeModal={closeModal}
//                     switchToSignup={() => {
//                         closeModal();
//                     }}
//                 />
//             )}
//         </>
//     );
// };

// export default PublicHeader;

// web view 



import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Login from '../../Authentication/Login';

const PublicHeader = () => {
    const [modalStep, setModalStep] = useState(null);
    // Added state to control the mobile menu
    const [isMenuOpen, setIsMenuOpen] = useState(false); 
    
    const navigate = useNavigate();
    const closeModal = () => setModalStep(null);

    return (
        <>
            <nav className="navbar navbar-expand-lg navbar-light bg-white shadow-sm fixed-top py-2">
                <div className="container">
                    {/* --- LOGO SECTION (Exact same as your original) --- */}
                    <Link className="navbar-brand d-flex align-items-center" to="/">
                        <svg width="52" height="52" viewBox="0 0 180 120" xmlns="http://www.w3.org/2000/svg" style={{ marginRight: '5px' }}>
                            <text x="0" y="90" fontFamily="Playfair Display, Didot, serif" fontSize="96" fontWeight="700" letterSpacing="-10" fill="#111">MF</text>
                        </svg>
                        <div className="d-flex flex-column">
                            <span style={{ fontSize: '1.05rem', fontWeight: '500', letterSpacing: '0.35rem', color: '#111', lineHeight: '1.1' }}>MUNNY FINDS</span>
                            <span style={{ fontSize: '0.55rem', letterSpacing: '0.25rem', fontWeight: '600', color: '#6b7280', marginTop: '2px' }}>BEAUTY & CARE</span>
                        </div>
                    </Link>

                    {/* --- THE HAMBURGER BUTTON --- */}
                    <button 
                        className="navbar-toggler shadow-none border-0" 
                        type="button" 
                        onClick={() => setIsMenuOpen(!isMenuOpen)} // Toggle state
                    >
                        <span className="navbar-toggler-icon"></span>
                    </button>

                    {/* --- THE LINKS (The part that was "missing") --- */}
                    {/* We use the isMenuOpen state to show/hide this div on mobile */}
                    <div className={`collapse navbar-collapse ${isMenuOpen ? 'show' : ''}`} id="navbarNav">
                        <ul className="navbar-nav mx-auto mb-2 mb-lg-0 gap-lg-3 text-center">
                            <li className="nav-item">
                                <Link className="nav-link fw-semibold text-dark" to="/" onClick={() => setIsMenuOpen(false)}>Home</Link>
                            </li>
                            <li className="nav-item">
                                <Link className="nav-link fw-semibold text-dark" to="/all-categories" onClick={() => setIsMenuOpen(false)}>Categories</Link>
                            </li>
                            <li className="nav-item">
                                <Link className="nav-link fw-semibold text-dark" to="/products/search" onClick={() => setIsMenuOpen(false)}>Products</Link>
                            </li>
                            <li className="nav-item">
                                <Link to="/about-us" className="nav-link fw-semibold text-dark" onClick={() => setIsMenuOpen(false)}>About Us</Link>
                            </li>
                            <li className="nav-item">
                                <Link to="/contact" className="nav-link fw-semibold text-dark" onClick={() => setIsMenuOpen(false)}>Contact</Link>
                            </li>
                        </ul>
                        
                        <div className="d-flex flex-column flex-lg-row align-items-center gap-3">
                            <button 
                                onClick={() => { setModalStep('login'); setIsMenuOpen(false); }} 
                                className="btn btn-link text-decoration-none fw-bold text-dark shadow-none"
                            >
                                Log In
                            </button>
                            
                            <button 
                                onClick={() => { navigate('/register-business'); setIsMenuOpen(false); }} 
                                className="btn px-4 py-2 fw-bold text-white rounded-3 shadow-sm" 
                                style={{ backgroundColor: '#059669', fontSize: '0.85rem', width: '100%' }}
                            >
                                <i className="ri-building-4-line me-1"></i> Business Owner
                            </button>
                        </div>
                    </div>
                </div>
            </nav>

            {modalStep === 'login' && <Login closeModal={closeModal} switchToSignup={() => closeModal()} />}
        </>
    );
};

export default PublicHeader;